import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const VanPage = lazy(() => import('../pages/van/page'));
const ToanPage = lazy(() => import('../pages/toan/page'));
const LyPage = lazy(() => import('../pages/ly/page'));
const HoaPage = lazy(() => import('../pages/hoa/page'));
const TinTucPage = lazy(() => import('../pages/tin-tuc/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/van',
    element: <VanPage />,
  },
  {
    path: '/van/phan-tich-bai-tho-viet-bac',
    element: lazy(() => import('../pages/van/phan-tich-bai-tho-viet-bac/page')),
  },
  {
    path: '/van/nghi-luan-xa-hoi',
    element: lazy(() => import('../pages/van/nghi-luan-xa-hoi/page')),
  },
  {
    path: '/van/chiec-luoc-nga',
    element: lazy(() => import('../pages/van/chiec-luoc-nga/page')),
  },
  {
    path: '/toan',
    element: <ToanPage />,
  },
  {
    path: '/toan/duong-trung-tuyen',
    element: lazy(() => import('../pages/toan/duong-trung-tuyen/page')),
  },
  {
    path: '/ly',
    element: <LyPage />,
  },
  {
    path: '/hoa',
    element: <HoaPage />,
  },
  {
    path: '/tin-tuc',
    element: <TinTucPage />,
  },
  {
    path: '/tin-tuc/phuong-phap-hoc-tap-hieu-qua',
    element: lazy(() => import('../pages/tin-tuc/phuong-phap-hoc-tap-hieu-qua/page')),
  },
  {
    path: '/tin-tuc/tieu-su-cau-thu-dinh-bac',
    element: lazy(() => import('../pages/tin-tuc/tieu-su-cau-thu-dinh-bac/page')),
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
